"use client";

import { useProjectConfigs } from "@/features/project/ProjectContext";
import { useProjectText } from "@/features/project/useProjectText";
import type { ItemProperties } from "@/types";
import { formatFieldValue } from "../../poiFields";
import { POIField } from "./POIField";
import { cn } from "@/lib/cn";

/**
 * One block of POI fields, addressed by index into `poiPageFields`.
 *
 * The legacy component took a `renderItem` callback and its only caller passed a
 * function that rendered a `POIField` — so the indirection existed to move
 * `poiFieldsView` down one level. It reads the config itself instead.
 */
export function POIFields({
  properties,
  index,
}: {
  properties: ItemProperties;
  index: number;
}) {
  const configs = useProjectConfigs();
  const t = useProjectText();

  const fields = configs.poiPageFields?.[index] ?? [];
  const inline = configs.poiFieldsView === "line";

  return (
    <div
      className={cn("flex flex-wrap gap-x-3 gap-y-2", {
        "flex-col": !inline,
      })}
    >
      {fields.map((field, position) => (
        <POIField
          key={field.field ?? position}
          field={field}
          value={formatFieldValue(
            field,
            field.field ? properties[field.field] : undefined,
            t,
          )}
        />
      ))}
    </div>
  );
}
